import { getConversationById, getDataFileById } from '../../apiClient';

import { useQuery } from '@tanstack/react-query';

const useGetConversationByIdQuery = (conversationId, enabled = true) =>
    useQuery({
        queryKey: ['conversation_id', conversationId],
        queryFn: async () => getConversationById(conversationId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetConversationByIdQuery;
